/**
 * Notification Service
 * Handles FCM token registration, notification fetching, and read status
 */

import api from '../utils/api';
import { requestNotificationPermission } from '../config/firebase';

/**
 * Request permission and register the FCM token with the backend
 * @returns {Promise<string|null>} FCM token or null
 */
export const registerForPushNotifications = async () => {
  try {
    const fcmToken = await requestNotificationPermission();
    if (!fcmToken) {
      return null;
    }

    await api.post('/notifications/register-token', {
      fcmToken,
      platform: 'web',
    });

    return fcmToken;
  } catch (error) {
    return null;
  }
};

/**
 * Get notifications for the logged-in customer
 * @returns {Promise<Array>} List of notifications
 */
export const getNotifications = async () => {
  const response = await api.get('/notifications');
  return response.data?.data || [];
};

/**
 * Mark a single notification as read
 * @param {string} notificationId - Notification ID
 */
export const markAsRead = async (notificationId) => {
  await api.put(`/notifications/${notificationId}/read`);
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async () => {
  await api.put('/notifications/read-all');
};

export const notificationService = {
  registerForPushNotifications,
  getNotifications,
  markAsRead,
  markAllAsRead,
};

export default notificationService;
